export enum ReefStatus {
	Provisioning = "Provisioning",
	ProvisioningFailed = "ProvisioningFailed",
	Live = "Live",
	Deleting = "Deleting"
}